import { Routes } from '@const/routes'

const useRoutes = (routes: Routes) => {
  return Object.keys(routes).map(key => routes[key])
}

export default useRoutes
